import Cookies from 'universal-cookie';
const cookies = new Cookies();
const cookieManagement = {

    saveClientTokenToCookie: function () {
        let domain = (window.location.hostname).split('.');
        let domainToken = 'REACT_APP_' + domain[0].toUpperCase() + '_TOKEN';
        cookies.set('clientToken', process.env[domainToken], {sameSite: 'lax'},{ path: '/' });
    },

    setClientSubDomainToCookie: function () {
        let domain = (window.location.hostname).split('.');
        cookies.set('clientSubDomain', domain[0], {sameSite: 'lax'},{ path: '/' });

        return domain[0];
    }

}

export default cookieManagement;
